import type { CSSProperties, JSX } from 'react';

import styles from './styles.module.css';

const STEPS: Array<{
  n: number;
  stepColor: string;
  stepText: string;
  title: string;
  body: string;
}> = [
  {
    n: 1,
    stepColor: 'var(--chip-orange)',
    stepText: '#fff',
    title: 'Submit the referral',
    body: 'Patient details, qualifying condition, and a few clinical readings. About 5 minutes.',
  },
  {
    n: 2,
    stepColor: 'var(--chip-yellow)',
    stepText: 'var(--forest)',
    title: 'We verify eligibility',
    body: 'A CMS eligibility check fires automatically; we confirm coverage before enrollment.',
  },
  {
    n: 3,
    stepColor: 'var(--chip-green)',
    stepText: '#fff',
    title: 'Patient is contacted',
    body: 'We reach out by email & text — featuring your name — to enroll them online.',
  },
  {
    n: 4,
    stepColor: 'var(--chip-teal)',
    stepText: '#fff',
    title: 'We coordinate care',
    body: 'If they enroll, we reach out to you with care-coordination next steps.',
  },
  {
    n: 5,
    stepColor: 'var(--coral)',
    stepText: '#fff',
    title: 'You stay informed',
    body: 'Milestones, labs, and the year-end outcomes summary flow back to you.',
  },
];

export function HowItWorks(): JSX.Element {
  return (
    <section className={`${styles.secPad} ${styles.stepsSection}`} id="how">
      <div className={styles.wrap}>
        <div className={styles.partner}>
          <div className={styles.partnerSeal}>
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
              <path d="M9 12l2 2 4-4" />
              <path d="M12 3 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6l-8-3Z" />
            </svg>
          </div>
          <div>
            <h3>We'll partner with you on care coordination</h3>
            <p>
              If your patient enrolls, NourishedRx reaches out to you with next steps for care
              coordination — how we'll share their lab results, send outcome updates, and flag
              anything that needs your attention throughout the year.
            </p>
            <div className={styles.partnerTagRow}>
              <span className={styles.partnerTag}>Lab sharing</span>
              <span className={styles.partnerTag}>Outcome updates</span>
              <span className={styles.partnerTag}>Escalation alerts</span>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.wrap} ${styles.center} ${styles.stepsHeadingWrap}`}>
        <span className={styles.eyebrow}>What to expect</span>
        <h2 className={styles.sectionH2}>From referral to graduation</h2>
      </div>

      <div className={styles.wrap}>
        <div className={styles.stepsH}>
          {STEPS.map((step) => (
            <div
              key={step.n}
              className={styles.step}
              style={
                {
                  '--step-color': step.stepColor,
                  '--step-text': step.stepText,
                } as CSSProperties
              }
            >
              <div className={styles.stepNum}>{step.n}</div>
              <h4>{step.title}</h4>
              <p>{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
